import cloneDeep from 'lodash.clonedeep';
import merge from 'lodash.merge';
import set from 'lodash.set';

import types from './constants';
import { states } from '../../values/enums';
import reportReducers from '../reducers';

const defaultReducer = (state, action) => (state)

const progressSelect = (state, action) => {
  let next = cloneDeep(state)
  const selection = action.selection
  set(next, 'selections', merge(next.selections, {[selection.type]: selection.data}))
  return next
}

const reportPending = (state, action) => {
  let next = cloneDeep(state);
  set(next, 'report.status', {type: states.PENDING});
  set(next, 'report.activities', []);
  set(next, 'report.data', null)
  return next;
}

const reportComplete = (state, action) => {
  let next = cloneDeep(state);
  set(next, 'report.status', {type: states.COMPLETE});
  set(next, 'report.activities', action.activities);
  set(next, 'report.data', action.report);
  return next;
}

const reportUpdated = (state, action) => {
  let next = cloneDeep(state);
  set(next, 'report.activities', action.activities);
  set(next, 'report.data', action.report);
  return next;
}

const reportError = (state, action) => {
  let next = cloneDeep(state)
  set(next, 'report.status', {type: states.ERROR, data: action.error})
  return next
}

const containerPending = (state, action) => {
  let next = cloneDeep(state)
  set(next, 'status', {type: states.PENDING})
  return next
}

const containerComplete = (state, action) => {
  let next = cloneDeep(state)
  set(next, 'status', {type: states.COMPLETE})
  return next
}

const containerError = (state, action) => {
  let next = cloneDeep(state)
  set(next, 'status', {type: states.ERROR, data: action.error})
  return next
}

const actionReducer = Object.assign({
  [types.PROGRESS_SELECT]: progressSelect,
  [types.PROGRESS_PENDING]: reportPending,
  [types.PROGRESS_COMPLETE]: reportComplete,
  [types.PROGRESS_UPDATED]: reportUpdated,
  [types.PROGRESS_ERROR]: reportError,

  // MOAHR NAMESPACINGZ PLEASE
  [types.CONTAINER_PENDING]: containerPending,
  [types.CONTAINER_COMPLETE]: containerComplete,
  [types.CONTAINER_ERROR]: containerError,
}, reportReducers);

export default (state = {}, action = {type: null}) => {
  const reducer = actionReducer[action.type] || defaultReducer
  return reducer(state, action)
}

// STATE: {reports: {progress: {
//   selections: {
//     {
//       classroom: {value: , label: },
//       metric: {value: , label: },
//       level: {value: , label: },
//     }
//   },
// }}}